<!-- Архивная папка для complaints -->
<script setup>
import { ref, computed } from 'vue'
import { slugify } from 'transliteration'
import { storeToRefs } from 'pinia'

import { useApi } from '@provise/composables/api'

import { useConfigsStore } from '@/stores/configs'

import SelectIdObject from '@/components/select/selectIdObject.vue'
import Mod from '@provise/components/mod.vue'

defineProps(['label', 'id'])
const model = defineModel()
const arcFolderVisible = ref(false)

const configStore = useConfigsStore()
const { config } = storeToRefs(configStore)

const options = computed(() => {
  return [
    ...(config.value?.complaints?.archive || []),
    { value: 'Новая архивная папка', customProperties: { emits: true } },
  ]
})
const { refresh: archFolderCreate, model: archFolder } = useApi({
  url: 'config',
  method: 'post',
})
async function onCreateArchFolder({ target: f }, mbs) {
  const fd = new FormData(f)
  const value = fd.get('name')
  const key = slugify(value)
  await archFolderCreate({ data: { entity_name: 'complaints', field: 'archive', key, value } })
  await configStore.fill()
  model.value = { id: archFolder.value.id }
  mbs.hide()
}
</script>
<template>
  <SelectIdObject
    :options="options"
    v-model="model"
    values="value"
    class="flex-grow-1"
    :auto-sort="false"
    @link-selected="arcFolderVisible = true"
  />

  <Mod @hidden="arcFolderVisible = false" v-if="arcFolderVisible" size="sm">
    <template #header>Добавить новую архивную папку</template>
    <template #default="{ mbs }">
      <form @submit.prevent="onCreateArchFolder($event, mbs)">
        <input type="text" class="form-control" name="name" />
        <div class="hstack gap-2 mt-3">
          <button class="btn btn-outline-primary">
            <i class="bi bi-check-square" />
            Сохранить
          </button>
          <button class="btn btn-danger" type="button" @click="mbs.hide()">
            <i class="bi bi-x-square" />
            Вернуться к обращению
          </button>
        </div>
      </form>
    </template>
  </Mod>
</template>
